import type { IPolarSeriesSpec, IPolarSeriesTheme } from '../interface';

export type IRoseLikeSeriesSpec = IPolarSeriesSpec;

export type IRoseLikeSeriesTheme = IPolarSeriesTheme;
